<template>
  <el-collapse-item class="sap-service-area" :name="data.CollapseName">
    <template #title>
      <div class="sap-service-header">
        <el-form key="formSAPService" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :model="data" :rules="rules"
          class="cs-el-input-container-small">
          <el-row class="bottomPrice" v-if="mode === 'bottomPrice'">
            <el-col :span="9">
              <el-form-item label-width="0px" prop="Name">
                <span>{{data.Name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="15">
              <el-form-item class="sap-service-label cs-no-margin-bottom" label="底价合计：">
                <label class="el-form-item__text">{{bottomPriceTotal}}</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="5">
              <el-form-item label-width="0px" prop="Name">
                <el-input :disabled="readonly" placeholder="请输入业务名称" v-model="data.Name" size="small" class="input-width" @click.native.stop />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item class="sap-service-label cs-no-margin-bottom" label="销售价合计：">
                <label class="el-form-item__text">{{salePriceTotal}}</label>
              </el-form-item>
              <el-form-item class="sap-service-label cs-no-margin-bottom" label="估算利润合计：">
                <label :class="{'el-form-item__text': true, 'cs-redLabel': calcProfitTotal.hasError}">{{calcProfitTotal.value}}</label>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item class="sap-service-label cs-no-margin-bottom" label="底价合计：">
                <label class="el-form-item__text">{{bottomPriceTotal}}</label>
              </el-form-item>
            </el-col>
            <el-col :span="5" style="text-align: right;">
              <el-form-item label-width="0px">
                <!-- <el-select :disabled="readonly" v-model="data.CommissionType" placeholder="请选择佣金类型" size="small">
                  <el-option v-for="item in GLOBAL.enumSACommissionType.getOptions()" :key="item.value" :label="item.desc" :value="item.value" />
                </el-select> -->
                <el-input :disabled="readonly" placeholder="请输入时间" size="small" class="input-width-limit" v-model="rangeLimitTemp.value"
                  oninput="value=value.replace(/[^0-9.]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(2):null" @click.native.stop>
                  <template #append>
                    <el-select :disabled="readonly" placeholder="请选择" class="input-append" size="small" v-model="rangeLimitTemp.type">
                      <el-option v-for="item in GLOBAL.enumSARangeLimitType.getOptions()" :key="item.value" :label="item.desc" :value="item.value" />
                    </el-select>
                  </template>
                </el-input>
                <el-button :disabled="!rangeLimitTemp.value" size="mini" type="text" @click.stop="onRangeLimitTempApply">应用</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="4" v-if="!readonly" style="text-align: right;">
              <el-form-item class="cs-no-margin-bottom" label-width="0px">
                <el-button size="small" type="danger" plain icon="el-icon-delete" @click.stop="deleteSAPService">删除该业务</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </template>
    <div v-if="isActive" class="sap-service-content">
      <div v-for="(item, index) in data.ServiceItems.filter(m => m.Enable)" :key="index" :name="item.Name">
        <sapServiceItem key="sapServiceItem" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com, index)" :mode="mode" :readonly="readonly"
          :estimatedCommission="estimatedCommission" :data="item" @delete="deleteSAPServiceItem" />
      </div>
    </div>
    <div v-if="mode === 'normal' && isActive && !readonly" height="auto" class="sap-service-footer">
      <el-button size="medium" type="text" icon="el-icon-plus" @click="addSAPServiceItem">添加服务小项</el-button>
    </div>
  </el-collapse-item>
</template>

<script>
import {
  calculateQuantityTotalBySI,
  calculateProfitBySI,
} from "@/core/studyAbroadHelper";

const defaultrangeLimitTemp = {
  value: null,
  type: 1,
};

const defaultSAPServiceItemModel = {
  Id: 0,
  Enable: true,
  ServiceId: 0,
  Name: null,
  ServiceType: 1,
  CostPriceCAD: null,
  CostPriceCNY: null,
  SalePriceCAD: null,
  SalePriceCNY: null,
  BottomPriceCAD: null,
  BottomPriceCNY: null,
  RangeLimitEnable: false,
  RangeLimitType: null,
  RangeLimitValue: null,
  CountLimitEnable: true,
  CountLimitType: 1,
  CountLimitValue: null,
  TimeLimitEnable: false,
  TimeLimitType: null,
  TimeLimitValue: null,
  Renewable: false,
  IsVIP: false,
  IsDataService: false,
  PriceCategoryInfos: [],
};

const mixin_generalMethods = {
  created() {
    this.backupData();
  },
  methods: {
    backupData(data = this.data) {
      this.originalData = Object.clone(data);
    },
    resetData() {
      if (!this.originalData) return;
      Object.copy(this.data, this.originalData);
    },
  },
  watch: {
    data: function (newVal) {
      this.backupData(newVal);
    },
  },
};

export default {
  name: "sapService",
  mixins: [mixin_generalMethods],
  components: {
    sapServiceItem: () => import("./sapServiceItem"),
  },
  props: {
    mode: {
      type: String,
      default: "normal",
      validator: (value) => ["normal", "bottomPrice"].contains(value),
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    estimatedCommission: {
      type: Number,
      default: 0.3,
    },
    data: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      originalData: null,
      rules: {
        Name: [
          {
            required: true,
            message: "请输入业务名称",
            trigger: "blur",
          },
          {
            max: 250,
            message: "超过最大字数",
            trigger: "blur",
          },
        ],
      },
      rangeLimitTemp: Object.clone(defaultrangeLimitTemp),
    };
  },
  computed: {
    costPriceTotal() {
      let priceCAD = this.data.ServiceItems.sum((item) =>
        `${item.CostPriceCAD}`.toNumber()
      );
      let priceCNY = this.data.ServiceItems.sum((preValue, item) =>
        `${item.CostPriceCNY}`.toNumber()
      );
      return `${Object.toCurrency(
        priceCAD,
        this.GLOBAL.currencyType.CAD
      )} | ${Object.toCurrency(priceCNY, this.GLOBAL.currencyType.CNY)}`;
    },
    salePriceTotal() {
      let priceCAD = this.data.ServiceItems.sum((item) => {
        let quantityTotal = calculateQuantityTotalBySI(item);
        return item.SalePriceCAD * quantityTotal;
      });
      let priceCNY = this.data.ServiceItems.sum((item) => {
        let quantityTotal = calculateQuantityTotalBySI(item);
        return item.SalePriceCNY * quantityTotal;
      });
      return `${Object.toCurrency(
        priceCAD,
        this.GLOBAL.currencyType.CAD
      )} | ${Object.toCurrency(priceCNY, this.GLOBAL.currencyType.CNY)}`;
    },
    bottomPriceTotal() {
      let priceCAD = this.data.ServiceItems.sum((item) => {
        let quantityTotal = calculateQuantityTotalBySI(item);
        return item.BottomPriceCAD * quantityTotal;
      });
      let priceCNY = this.data.ServiceItems.sum((item) => {
        let quantityTotal = calculateQuantityTotalBySI(item);
        return item.BottomPriceCNY * quantityTotal;
      });
      return `${Object.toCurrency(
        priceCAD,
        this.GLOBAL.currencyType.CAD
      )} | ${Object.toCurrency(priceCNY, this.GLOBAL.currencyType.CNY)}`;
    },
    calcProfitTotal() {
      let profitCAD = this.data.ServiceItems.sum((item) =>
        calculateProfitBySI(
          item,
          this.estimatedCommission,
          this.GLOBAL.currencyType.CAD
        )
      );
      let profitCNY = this.data.ServiceItems.sum((item) =>
        calculateProfitBySI(
          item,
          this.estimatedCommission,
          this.GLOBAL.currencyType.CNY
        )
      );
      return {
        hasError: profitCAD < 0 || profitCNY < 0,
        value: `${Object.toCurrency(
          profitCAD,
          this.GLOBAL.currencyType.CAD
        )} | ${Object.toCurrency(profitCNY, this.GLOBAL.currencyType.CNY)}`,
      };
    },
  },
  methods: {
    onRangeLimitTempApply() {
      this.$confirm(
        `您确定要修改该服务${
          !!this.data.Name ? " - " + this.data.Name : String.empty
        }下所有小项的时间吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.data.ServiceItems.forEach((item) => {
            item.RangeLimitEnable = true;
            item.RangeLimitType = this.rangeLimitTemp.type;
            item.RangeLimitValue = this.rangeLimitTemp.value;

            if (item.CountLimitEnable) {
              item.CountLimitType = this.GLOBAL.enumSACountLimitType.Total;
            }
            if (item.TimeLimitEnable) {
              item.TimeLimitType = this.GLOBAL.enumSATimeLimitType.Total;
            }
          });

          this.rangeLimitTemp = Object.clone(defaultrangeLimitTemp);
        })
        .catch(() => {});
    },
    deleteSAPService() {
      this.$confirm(
        `您确定要删除该业务${
          !!this.data.Name ? " - " + this.data.Name : String.empty
        }吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          if (!!this.data.Id) this.resetData();
          this.$emit("delete", this.data);
        })
        .catch(() => {});
    },
    addSAPServiceItem() {
      let newDataModel = Object.clone(defaultSAPServiceItemModel);
      let pciOptions = this.GLOBAL.enumStudyAbroadPriceCategory.getOptions();
      newDataModel.PriceCategoryInfos = pciOptions.map((item) => ({
        Id: 0,
        Enable: true,
        ServiceItemId: newDataModel.Id,
        PriceCategory: item.value,
        SalePriceCAD: 0,
        SalePriceCNY: 0,
        BottomPriceCAD: 0,
        BottomPriceCNY: 0,
      }));
      this.data.ServiceItems.push(newDataModel);
    },
    deleteSAPServiceItem(dataModel) {
      if (!dataModel.Id) {
        this.data.ServiceItems.remove(dataModel);
        return;
      }

      dataModel.Enable = false;
    },
    validate() {
      let isValid = true;

      let refCom = this.$vueRefStore.getChildrenRef("formSAPService");
      if (!!refCom) {
        refCom.validate((valid) => {
          isValid = valid;
        });
      }

      let refComList = this.$vueRefStore.getChildrenRefs("sapServiceItem");
      if (!!refComList && refComList.length > 0) {
        refComList.forEach((com) => {
          let result = com.validate();
          if (isValid) isValid = result;
        });
      }

      return isValid;
    },
  },
  watch: {
    isActive(newVal) {
      if (newVal) {
        this.$nextTick(() => {
            this.$el.scrollIntoView();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sap-service-area {
  /deep/ .el-collapse-item__header {
    height: auto;
    line-height: inherit;
    background-color: rgb(227, 227, 227);
  }

  /deep/ .el-collapse-item__wrap {
    border-bottom: 0;

    .el-collapse-item__content {
      padding-bottom: 0;
    }
  }

  .sap-service-header {
    width: 100%;
    margin: 20px;

    .el-row {
      &.bottomPrice {
        .el-form-item {
          margin-bottom: 0;

          span {
            font-weight: bold;
          }

          /deep/ label {
            margin-bottom: 0;
          }
        }
      }
    }

    .el-form-item {
      margin-bottom: 0;

      /deep/ .el-form-item__label {
        margin-bottom: 0;
      }

      .el-form-item__text {
        color: #606266;

        &.cs-redLabel {
          color: red;
        }
      }
    }

    .el-input {
      /deep/ .el-input__inner {
        font-weight: bold;
      }
    }

    .el-select {
      width: 90%;

      /deep/ .el-input__inner {
        font-weight: bold;
      }
    }

    .el-button {
      font-weight: bold;
    }
  }

  .sap-service-content {
    background-color: whitesmoke;
    padding: 0;
  }

  .sap-service-footer {
    background-color: whitesmoke;
    text-align: left;
  }

  .sap-service-label {
    font-weight: bold;

    .el-input {
      width: 50%;

      /deep/ .el-input__inner {
        background-color: transparent;
        color: #606266;
        border-color: transparent;
        padding: 0;
      }
    }
  }

  .input-width {
    font-size: 15px;
    width: 90%;
  }

  .input-width-limit {
    padding: 5px 0;
    width: 80%;
  }

  .input-append {
    margin: -10px -10px;
    width: 70px !important;
  }

  .delete-button {
    float: right;
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/priceManagement/sapService.vue